/* Natura Amica — upload this file to Assets; load once with defer.
 * Remove the old Enooso script. Shopify automatic discounts are REQUIRED.
 * Fitopreparatori: confirm that 62800225239427 is the gift VARIANT ID.
 * Gift price must be > 0. This browser script is not checkout validation.
 * Enooso thresholds: EUR 39; CHF 36.32; PLN 170.96. Fixed ECB conversion 2026-10-09.
 * Shopify discount conversion can differ; align the discount and advertised thresholds.
 */
(() => {
  'use strict';
  if (window.NaturaAmicaGifts) return;
  const promotions = [
    { id: 'enooso', vendor: 'enooso', variantId: '62585502630275', productId: '16305352769923',
      property: '_enooso_omaggio', minQuantity: 0, minSpend: { EUR: 3900, CHF: 3632, PLN: 17096 },
      end: '2026-11-15T23:59:59+01:00', name: 'Sacchetto portasapone', enabled: true },
    { id: 'fitopreparatori', vendor: 'Fitopreparatori Italiani', variantId: '62800225239427', productId: null,
      property: '_fitopreparatori_omaggio', minQuantity: 2, minSpend: null,
      qualifyingIds: ['62800414278019', '62800414212483', '62800414179715',
        '62800414146947', '62800414114179', '62800414081411'],
      quantityMultipliers: { '62800414179715': 3 }, // Matches variant_id or product_id; one pack = 3 units.
      end: null, name: 'Fitopreparatori Italiani', enabled: true }
  ];
  const words = {
    it: ['Un regalo per te', 'Aggiungi gratis', 'No, grazie', 'Regalo aggiunto gratuitamente', 'Il regalo non è disponibile gratuitamente. Riprova più tardi.', 'Con 2 prodotti selezionati Fitopreparatori Italiani o una confezione promo da 3, ricevi una spazzola in omaggio.', 'Con almeno 39 € di prodotti Enooso, ricevi un sacchetto portasapone in omaggio.'],
    de: ['Ein Geschenk für dich', 'Gratis hinzufügen', 'Nein, danke', 'Geschenk kostenlos hinzugefügt', 'Das Geschenk ist derzeit nicht kostenlos verfügbar. Versuche es später erneut.', 'Mit 2 ausgewählten Fitopreparatori Italiani-Artikeln oder einer Aktionspackung mit 3 Stück erhältst du eine Bürste gratis.', 'Ab einem Einkauf von 39 € mit Enooso-Produkten erhältst du ein Seifensäckchen gratis.'],
    en: ['A gift for you', 'Add for free', 'No, thanks', 'Free gift added', 'The gift is not available for free. Please try again later.', 'Buy 2 selected Fitopreparatori Italiani items or one promotional 3-pack and receive a free brush.', 'Spend €39 or more on Enooso products and receive a free soap pouch.'],
    es: ['Un regalo para ti', 'Añadir gratis', 'No, gracias', 'Regalo añadido gratis', 'El regalo no está disponible gratuitamente. Inténtalo más tarde.', 'Compra 2 productos seleccionados Fitopreparatori Italiani o un pack promocional de 3 y recibe un cepillo gratis.', 'Compra al menos 39 € en productos Enooso y recibe una bolsita para jabón gratis.'],
    fr: ['Un cadeau pour vous', 'Ajouter gratuitement', 'Non, merci', 'Cadeau ajouté gratuitement', 'Le cadeau ne peut pas être ajouté gratuitement. Réessayez plus tard.', 'Achetez 2 articles sélectionnés Fitopreparatori Italiani ou un lot promotionnel de 3 et recevez une brosse offerte.', 'Dès 39 € d’achat de produits Enooso, recevez un sachet à savon offert.'],
    nl: ['Een cadeau voor jou', 'Gratis toevoegen', 'Nee, bedankt', 'Gratis cadeau toegevoegd', 'Het cadeau is niet gratis beschikbaar. Probeer het later opnieuw.', 'Koop 2 geselecteerde Fitopreparatori Italiani-artikelen of één promotiepakket van 3 en ontvang een gratis borstel.', 'Bij minimaal € 39 aan Enooso-producten ontvang je een gratis zeepzakje.'],
    pl: ['Prezent dla Ciebie', 'Dodaj gratis', 'Nie, dziękuję', 'Dodano bezpłatny prezent', 'Prezent nie jest dostępny bezpłatnie. Spróbuj ponownie później.', 'Kup 2 wybrane produkty Fitopreparatori Italiani lub jeden zestaw promocyjny 3 sztuk i otrzymaj szczotkę gratis.', 'Kup produkty Enooso za co najmniej 39 € i otrzymaj woreczek na mydło gratis.'],
    pt: ['Uma oferta para si', 'Adicionar grátis', 'Não, obrigado', 'Oferta adicionada gratuitamente', 'A oferta não está disponível gratuitamente. Tente mais tarde.', 'Compre 2 artigos selecionados Fitopreparatori Italiani ou um conjunto promocional de 3 e receba uma escova de oferta.', 'Na compra de pelo menos 39 € em produtos Enooso, receba um saquinho para sabonete de oferta.']
  };
  const tr = words[(document.documentElement.lang || 'it').toLowerCase().split('-')[0]] || words.it;
  const stockMessages = {
    it: 'Il regalo al momento non è disponibile. Scrivici in chat per informazioni.',
    de: 'Das Geschenk ist derzeit nicht verfügbar. Frag uns im Chat nach der Verfügbarkeit.',
    en: 'The gift is currently unavailable. Ask us in the chat about availability.',
    es: 'El regalo no está disponible actualmente. Consúltanos por chat.',
    fr: 'Le cadeau est actuellement indisponible. Contactez-nous par chat pour en savoir plus.',
    nl: 'Het cadeau is momenteel niet beschikbaar. Vraag ons in de chat naar de beschikbaarheid.',
    pl: 'Prezent jest obecnie niedostępny. Zapytaj nas na czacie o dostępność.',
    pt: 'A oferta está de momento indisponível. Contacte-nos pelo chat para saber mais.'
  };
  const stockText = stockMessages[(document.documentElement.lang || 'it').toLowerCase().split('-')[0]] || stockMessages.it;
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  const state = new Map(promotions.map(p => [p.id, { declined: false, error: false, unavailable: false }]));
  let cart = null, busy = false, pending = false, timer, rendering = false;
  const norm = value => String(value || '').trim().toLowerCase();
  const giftProduct = item => promotions.some(p => String(item.variant_id) === p.variantId ||
    (p.productId && String(item.product_id) === p.productId));
  const lines = (c, p) => c.items.filter(i => String(i.variant_id) === p.variantId && i.properties?.[p.property] === '1');
  function eligible(c, p) {
    if (!p.enabled || (p.end && Date.now() > Date.parse(p.end))) return false;
    const multiplier = i => p.quantityMultipliers?.[String(i.variant_id)] || p.quantityMultipliers?.[String(i.product_id)] || 1;
    const items = c.items.filter(i => !giftProduct(i) && (p.qualifyingIds
      ? p.qualifyingIds.includes(String(i.variant_id)) || p.qualifyingIds.includes(String(i.product_id))
      : norm(i.vendor) === norm(p.vendor))); 
    if (p.minQuantity && items.reduce((n, i) => n + i.quantity * multiplier(i), 0) < p.minQuantity) return false;
    if (p.minSpend) {
      const minimum = p.minSpend[c.currency];
      if (!Number.isFinite(minimum)) return false;
      if (items.reduce((n, i) => n + i.final_line_price, 0) < minimum) return false;
    }
    return true;
  }
  async function request(path, body) {
    const response = await originalFetch(root + path, body ? {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : { credentials: 'same-origin', cache: 'no-store' });
    const result = await response.json();
    if (!response.ok) {
      const error = new Error(result.description || 'Cart request failed');
      error.status = response.status;
      error.path = path;
      throw error;
    }
    return result;
  }
  const readCart = () => request('cart.js');
  // Re-read before every mutation: automatic discounts can change line keys.
  async function removePromo(p) {
    for (let n = 0; n < 20; n++) {
      const current = await readCart();
      const line = lines(current, p)[0];
      if (!line) return current;
      await request('cart/change.js', { id: line.key, quantity: 0 });
    }
    throw new Error('Too many gift lines');
  }
  function drawer() { return document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer], .mini-cart, #mini-cart'); }
  function targets() {
    const result = [], d = drawer();
    const selector = '.drawer__footer, .cart-drawer__footer, .mini-cart__footer, [data-cart-footer], .cart-footer';
    const footer = d?.querySelector(selector) || d?.querySelector('[name="checkout"]')?.parentElement;
    if (footer) result.push(footer);
    if (/\/cart\/?$/.test(location.pathname)) {
      const target = [...document.querySelectorAll('#main-cart-footer, .main-cart-footer, .cart__footer, .cart-footer')].find(e => !d?.contains(e));
      if (target) result.push(target);
    }
    return [...new Set(result)];
  }
  const mobilePanels = new Map();
  const detailLabels = { it: 'Dettagli', de: 'Details', en: 'Details', es: 'Detalles', fr: 'Détails', nl: 'Details', pl: 'Szczegóły', pt: 'Detalhes' };
  const detailLabel = detailLabels[(document.documentElement.lang || 'it').toLowerCase().split('-')[0]] || detailLabels.it;
  function mobilePanel(box, p, status) {
    let panel = mobilePanels.get(p.id);
    if (!panel || panel.status !== status) {
      panel = { status, collapsed: true };
      mobilePanels.set(p.id, panel);
    }
    const details = [...box.children].filter(child => child.tagName !== 'STRONG' && !child.classList.contains('na-gift-actions'));
    const applyCollapsed = () => {
      box.classList.toggle('na-gift-compact', panel.collapsed);
      for (const child of details) {
        child.hidden = panel.collapsed;
        if (panel.collapsed) child.style.setProperty('display', 'none', 'important');
        else child.style.removeProperty('display');
      }
    };
    applyCollapsed();
    box.dataset.promo = p.id;
    box.classList.toggle('na-gift-compact', panel.collapsed);
    const toggle = document.createElement('button');
    toggle.type = 'button'; toggle.className = 'na-gift-toggle';
    toggle.textContent = detailLabel;
    toggle.setAttribute('aria-expanded', String(!panel.collapsed));
    toggle.addEventListener('click', event => {
      event.preventDefault(); event.stopPropagation();
      panel.collapsed = !panel.collapsed;
      applyCollapsed();
      toggle.setAttribute('aria-expanded', String(!panel.collapsed));
      observer?.takeRecords();
    });
    box.append(toggle);
  }
  function render() {
    if (!cart) return;
    rendering = true;
    document.querySelectorAll('.na-gifts').forEach(e => e.remove());
    for (const target of targets()) {
      const container = document.createElement('div'); container.className = 'na-gifts';
      for (const p of promotions) {
        const s = state.get(p.id), gift = lines(cart, p)[0];
        if (!eligible(cart, p) || (s.declined && !gift) || (!gift && cart.items.some(i => String(i.variant_id) === p.variantId))) continue;
        const box = document.createElement('div'); box.className = 'na-gift';
        const title = document.createElement('strong'); title.textContent = '🎁 ' + (gift?.final_line_price === 0 ? tr[3] : tr[0]);
        box.append(title);
        const text = document.createElement('p');
        let offerText = tr[p.id === 'enooso' ? 6 : 5];
        if (p.minSpend && p.minSpend[cart.currency] !== undefined) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'it', {
            style: 'currency', currency: cart.currency
          }).format(p.minSpend[cart.currency] / 100);
          offerText = offerText.replace(/39\s*€|€\s*39/g, amount);
        }
        text.textContent = s.unavailable ? stockText : s.error ? tr[4] : offerText;
        text.setAttribute('role', (s.error || s.unavailable) ? 'alert' : 'status'); box.append(text);
        if (gift?.image) { const img = document.createElement('img'); img.src = gift.image; img.alt = gift.product_title || p.name; img.width = 60; img.height = 60; img.loading = 'lazy'; box.prepend(img); }
        if (!gift && !s.unavailable) {
          const actions = document.createElement('div'); actions.className = 'na-gift-actions';
          const add = document.createElement('button'); add.type = 'button'; add.textContent = tr[1]; add.disabled = busy;
          add.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); accept(p); });
          const decline = document.createElement('button'); decline.type = 'button'; decline.className = 'na-decline'; decline.textContent = tr[2];
          ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(name => decline.addEventListener(name, e => e.stopPropagation(), { passive: true }));
          decline.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); s.declined = true; saveDecline(p, true); render(); });
          actions.append(add, decline); box.append(actions);
        }
        mobilePanel(box, p, s.unavailable ? 'unavailable' : s.error ? 'error' : gift ? 'added' : 'offer');
        container.append(box);
      }
      if (container.childElementCount) {
        const d = drawer();
        const isDrawerFooter = d?.contains(target) && target.matches('.drawer__footer, .cart-drawer__footer, .mini-cart__footer, [data-cart-footer], .cart-footer');
        // Keep the promo attached to the footer, directly above its tools.
        if (isDrawerFooter) target.prepend(container);
        else target.before(container);
      }
    }
    observer?.takeRecords(); rendering = false;
  }
  function saveDecline(p, value) { try { sessionStorage.setItem('na-gift-decline-' + p.id, value ? '1' : '0'); } catch (_) {} }
  for (const p of promotions) { try { state.get(p.id).declined = sessionStorage.getItem('na-gift-decline-' + p.id) === '1'; } catch (_) {} }
  async function refreshTheme() {
    // Dawn-compatible section replacement preserves the drawer host/open state.
    const d = drawer();
    const sections = new Set();
    if (d?.getSectionsToRender) for (const s of d.getSectionsToRender()) sections.add(s.section || s.id);
    if (document.getElementById('CartDrawer')) sections.add('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) sections.add('cart-icon-bubble');
    if (/\/cart\/?$/.test(location.pathname)) for (const e of document.querySelectorAll('[data-id]')) {
      if (e.matches('cart-items, cart-footer') || e.id === 'main-cart-items' || e.id === 'main-cart-footer') sections.add(e.dataset.id);
    }
    if (sections.size) {
      const response = await originalFetch(root + '?sections=' + encodeURIComponent([...sections].slice(0, 5).join(',')) + '&sections_url=' + encodeURIComponent(location.pathname), { cache: 'no-store' });
      if (response.ok) {
        const html = await response.json();
        for (const [id, value] of Object.entries(html)) {
          if (!value) continue;
          const doc = new DOMParser().parseFromString(value, 'text/html');
          if (id === 'cart-drawer') {
            const old = document.querySelector('#CartDrawer .drawer__inner'), next = doc.querySelector('#CartDrawer .drawer__inner');
            if (old && next) old.replaceWith(next);
            d?.classList.toggle('is-empty', cart.item_count === 0);
          } else if (id === 'cart-icon-bubble') {
            const old = document.getElementById(id), next = doc.getElementById(id);
            if (old && next) old.innerHTML = next.innerHTML;
          } else {
            const old = document.getElementById('shopify-section-' + id), next = doc.getElementById('shopify-section-' + id);
            if (old && next) old.replaceWith(next);
          }
        }
      }
    }
    // Other themes may listen to cart:refresh; exact adapter depends on theme.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'na-gifts', cart } }));
    render();
  }
  async function accept(p) {
    if (busy) return;
    busy = true; const s = state.get(p.id); s.error = false;
    // Close the details immediately, before the gift/cart request starts.
    const panel = mobilePanels.get(p.id);
    if (panel) panel.collapsed = true;
    render();
    let changed = false;
    try {
      cart = await readCart();
      if (!eligible(cart, p) || cart.items.some(i => String(i.variant_id) === p.variantId)) return;
      await request('cart/add.js', { items: [{ id: p.variantId, quantity: 1, properties: { [p.property]: '1' } }] });
      changed = true; cart = await readCart();
      const added = lines(cart, p);
      if (!eligible(cart, p) || added.length !== 1 || added[0].final_line_price !== 0) {
        cart = await removePromo(p); s.error = true;
      } else { s.declined = false; saveDecline(p, false); }
    } catch (error) {
      console.error('[Natura Amica gifts]', error); s.error = true;
      if (error.path === 'cart/add.js' && error.status === 422) s.unavailable = true;
      // A network error may occur AFTER Shopify accepted the addition.
      try { cart = await readCart(); const added = lines(cart, p); if (added.some(i => i.final_line_price !== 0) || !eligible(cart, p)) { cart = await removePromo(p); changed = true; } } catch (cleanupError) { console.error('[Gift cleanup]', cleanupError); }
    } finally {
      if (changed) { try { await refreshTheme(); } catch (error) { console.error('[Gift cart refresh]', error); } }
      busy = false; render(); schedule();
    }
  }
  async function sync() {
    if (busy) { pending = true; return; }
    busy = true; pending = false; let changed = false;
    try {
      cart = await readCart();
      for (const p of promotions) {
        const s = state.get(p.id), gifts = lines(cart, p), qualifies = eligible(cart, p);
        if (!qualifies) { mobilePanels.delete(p.id); s.declined = false; s.error = false; s.unavailable = false; saveDecline(p, false); }
        if (gifts.length && (!qualifies || gifts.length > 1 || gifts[0].quantity !== 1 || gifts[0].final_line_price !== 0)) {
          s.error = qualifies; cart = await removePromo(p); changed = true;
        }
      }
      if (changed) await refreshTheme();
    } catch (error) { console.error('[Natura Amica gifts]', error); }
    finally { busy = false; render(); if (pending) schedule(); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 400); }
  const mutationURL = value => {
    try { const url = new URL(value, location.href); return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname); } catch (_) { return false; }
  };
  window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    if (mutationURL(typeof args[0] === 'string' || args[0] instanceof URL ? String(args[0]) : args[0]?.url)) schedule();
    return response;
  };
  // Also observe themes using XMLHttpRequest, without polling cart.js.
  const open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  const watched = new WeakSet();
  XMLHttpRequest.prototype.open = function (method, url, ...rest) { watched.delete(this); if (mutationURL(url)) watched.add(this); return open.call(this, method, url, ...rest); };
  XMLHttpRequest.prototype.send = function (...args) { if (watched.has(this)) this.addEventListener('loadend', schedule, { once: true }); return send.apply(this, args); };
  let observer;
  function start() {
    const style = document.createElement('style'); style.textContent = '.na-gift .na-gift-toggle{display:inline-block;background:transparent;color:#0f6248;padding:4px 8px;margin-left:8px;font-size:12px;text-decoration:underline}.na-gift.na-gift-compact{padding:8px 10px}.na-gift-compact p,.na-gift-compact img{display:none}.na-gift-compact .na-gift-actions{margin-top:8px}.na-gift-compact strong{font-size:13px}.na-gifts{flex:0 0 auto;width:100%;box-sizing:border-box;margin:0 0 8px}.na-gift{padding:15px;margin:0 0 8px;border:1px solid #0f62482e;border-radius:12px;background:#f7faf8;color:#0f6248;font-family:inherit}.na-gift p{font-size:13px;line-height:1.5;margin:8px 0 12px}.na-gift strong{font-size:15px}.na-gift img{object-fit:contain;float:right;margin:0 0 8px 10px}.na-gift-actions{display:flex;gap:12px;align-items:center;flex-wrap:wrap}.na-gift button{font:inherit;font-size:13px;cursor:pointer;border:0;border-radius:8px;padding:11px 14px;background:#0f6248;color:white}.na-gift button:disabled{opacity:.55;cursor:wait}.na-gift .na-decline{background:transparent;color:#666;text-decoration:underline}.na-gift::after{content:"";display:block;clear:both}'; document.head.append(style);
    observer = new MutationObserver(mutations => {
      if (rendering) return;
      // DOM redraws only repaint cached state: they never trigger cart API reads.
      if (mutations.some(m => [...m.addedNodes, ...m.removedNodes].some(n => n.nodeType === 1 && !n.matches('.na-gifts')))) render();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    for (const event of ['cart:updated', 'cart:change', 'cart:refresh']) document.addEventListener(event, e => { if (e.detail?.source !== 'na-gifts') schedule(); });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    schedule();
  }
  window.NaturaAmicaGifts = { promotions, refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
